import { render, staticRenderFns } from "./WeekComponentNew.vue?vue&type=template&id=3e6b5a07&scoped=true"
import script from "./WeekComponentNew.vue?vue&type=script&lang=js"
export * from "./WeekComponentNew.vue?vue&type=script&lang=js"
import style0 from "./WeekComponentNew.vue?vue&type=style&index=0&id=3e6b5a07&prod&lang=css"
import style1 from "./WeekComponentNew.vue?vue&type=style&index=1&id=3e6b5a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b5a07",
  null
  
)

export default component.exports